/**
 * Variant Tabs – Mr Parker Theme (v8.8.0)
 * Uses metafield: custom.variant_description
 */

(function () {
  function updateVariantTabs(variant) {
    if (!variant || !window.variantTabsData) return;

    const variantData = window.variantTabsData[variant.id];
    if (!variantData) return;

    const bundleEl = document.getElementById('variant-bundle');
    if (!bundleEl) return;

    bundleEl.innerHTML =
      variantData.description || '<p>No variant description available.</p>';
  }

  // Initial load
  document.addEventListener('DOMContentLoaded', function () {
    if (window.currentVariant) {
      updateVariantTabs(window.currentVariant);
    }
  });

  // Shopify / Mr Parker variant change
  document.addEventListener('variant:change', function (event) {
    if (event?.detail?.variant) {
      updateVariantTabs(event.detail.variant);
    }
  });

  // Fallback for variant ID changes
  document.addEventListener('change', function (event) {
    const variantInput = event.target.closest('[name="id"]');
    if (!variantInput) return;

    const variantId = parseInt(variantInput.value, 10);
    if (!variantId) return;

    updateVariantTabs({ id: variantId });
  });
})();
